export default "__VITE_ASSET__BMPUGCdY__"